module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../node_modules/babel-loader/lib/index.js!./FakePageNotFound.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/FakePageNotFound.js
// module id = 1243
// module chunks = 58